import React from 'react';
import './ct-basic.css';
import './ct-basic-responsive.css';
import './ct-footer.css';
import './ct-footer-responsive.css';

const CtFoot = () => (
  <div className="ct-foot">
    <div id="wrapper-footer" className="clearfix">
      <div className="wrapper clearfix" role="contentinfo">
        <div className="box-left clearfix">
          <div className="panel-footer first-desktop">
            <h3 className="s_160p">
              <a href="//ceskatelevize.cz/ct24/" title="Zpravodajství">
                Zpravodajství
              </a>
            </h3>
            <ul>
              <li>
                <a
                  href="//ceskatelevize.cz/ct24/zive-vysilani/"
                  title="Živé vysílání ČT24"
                >
                  Živé vysílání ČT24
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/ct24/pocasi/" title="Počasí">
                  Počasí
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/ct24/porady-ct24/"
                  title="Pořady ČT24"
                >
                  Pořady ČT24
                </a>
              </li>
            </ul>
          </div>
          <div className="panel-footer">
            <h3 className="s_160p">
              <a href="//ceskatelevize.cz/sport/" title="Sport">
                Sport
              </a>
            </h3>
            <ul>
              <li>
                <a
                  href="//ceskatelevize.cz/sport/zive-vysilani/"
                  title="Živé vysílání ČT sport"
                >
                  Živé vysílání ČT sport
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/sport/porady-ct-sport/"
                  title="Pořady ČT sport"
                >
                  Pořady ČT sport
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/sport/tabulky/"
                  title="Tabulky a výsledky"
                >
                  Tabulky a výsledky
                </a>
              </li>
            </ul>
          </div>
          <div className="panel-footer">
            <h3 className="s_160p">
              <a href="//ceskatelevize.cz/ivysilani/" title="iVysílání">
                iVysílání
              </a>
            </h3>
            <ul>
              <li>
                <a href="//ceskatelevize.cz/ivysilani/zive/ct24/" title="Živě">
                  Živě
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/ivysilani/podle-abecedy/"
                  title="Videoarchiv A-Z"
                >
                  Videoarchiv A-Z
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/ivysilani/podle-data-vysilani/"
                  title="Videoarchiv podle data"
                >
                  Videoarchiv podle data
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/ivysilani/moje/"
                  title="Moje iVysílání"
                >
                  Moje iVysílání
                </a>
              </li>
            </ul>
          </div>
          <div className="panel-footer">
            <h3 className="s_160p">
              <a href="//ceskatelevize.cz/tv-program/" title="TV program">
                TV program
              </a>
            </h3>
            <ul>
              <li>
                <a href="//ceskatelevize.cz/tv-program/" title="Dnešní program">
                  Dnešní program
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/tv-program/osobni/"
                  title="Osobní program"
                >
                  Osobní program
                </a>
              </li>
            </ul>
          </div>

          <div className="panel-footer first-desktop">
            <h3 className="s_160p">
              <a href="//ceskatelevize.cz/porady/a-z/" title="Pořady A-Z">
                Pořady A-Z
              </a>
            </h3>
            <ul>
              <li>
                <a
                  href="//ceskatelevize.cz/porady/tema/"
                  title="Pořady podle témat"
                >
                  Pořady podle témat
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/porady/mapa/"
                  title="Pořady na mapě"
                >
                  Pořady na mapě
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/filmy/" title="Zveme vás do kina">
                  Zveme vás do kina
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/porady/vyroci/" title="Výročí">
                  Výročí
                </a>
              </li>
            </ul>
          </div>
          <div className="panel-footer">
            <h3 className="s_160p">
              <a href="//ceskatelevize.cz/vse-o-ct/" title="Vše o ČT">
                Vše o ČT
              </a>
            </h3>
            <ul>
              <li>
                <a href="//ceskatelevize.cz/brno/" title="Studio Brno">
                  Studio Brno
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/ostrava/" title="Studio Ostrava">
                  Studio Ostrava
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/decko-pro-rodice/uvod/"
                  title="Déčko pro rodiče"
                >
                  Déčko pro rodiče
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/vse-o-ct/press/" title="Pro média">
                  Pro média
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/vse-o-ct/podavani-nametu-a-projektu/"
                  title="Pro autory"
                >
                  Pro autory
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/vse-o-ct/vyberova-rizeni-konkurzy/konkurzy-pozvanky-na-nataceni/"
                  title="Konkurzy"
                >
                  Konkurzy
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/vse-o-ct/kariera/" title="Kariéra">
                  Kariéra
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/vse-o-ct/kontakty/"
                  title="Kontakty"
                >
                  Kontakty
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/faq/" title="Časté dotazy">
                  Časté dotazy
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/vse-o-ct/rada-ct/" title="Rada ČT">
                  Rada ČT
                </a>
              </li>
            </ul>
          </div>
          <div className="panel-footer">
            <h3 className="s_160p">
              <a
                href="//ceskatelevize.cz/vse-o-ct/podavani-nametu-a-projektu/"
                title="Pro partnery"
              >
                Pro partnery
              </a>
            </h3>
            <ul>
              <li>
                <a
                  href="//ceskatelevize.cz/vse-o-ct/produkcni-sluzby/"
                  title="Produkční služby"
                >
                  Produkční služby
                </a>
              </li>
              <li>
                <a
                  href="//ceskatelevize.cz/vse-o-ct/podavani-nametu-a-projektu/"
                  title="Podávání námětů a projektů"
                >
                  Podávání námětů a&nbsp;projektů
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/telexport/" title="Telexport">
                  Telexport
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/vse-o-ct/reklama/" title="Reklama">
                  Reklama
                </a>
              </li>
            </ul>
          </div>
          <div className="panel-footer">
            <ul>
              <li>
                <a href="//ceskatelevize.cz/teletext/" title="Teletext">
                  Teletext
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/moje-ct/" title="Moje ČT">
                  Moje ČT
                </a>
              </li>
              <li>
                <a href="//ceskatelevize.cz/eshop/" title="eShop">
                  eShop
                </a>
              </li>
              <li>
                <a
                  href="//tvp.ceskatelevize.cz/poplatky/"
                  title="TV poplatek"
                >
                  TV poplatek
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="box-right">
          <div className="panel-footer">
            <div className="footer-channels">
              <div className="clearfix">
                <div className="w_1of2 first ct1">
                  <a
                    href="//ceskatelevize.cz/ct1/"
                    title="ČT1"
                    className="hovering"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ct1-footer.png?_ts=1366977075"
                      alt="ČT1"
                      title="ČT1"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ct1-footer-hover.png?_ts=1366977078"
                      alt="ČT1"
                      title="ČT1"
                      className="on-hover"
                    />
                  </a>
                </div>
                <div className="w_1of2 ct2">
                  <a
                    href="//ceskatelevize.cz/ct2/"
                    title="ČT2"
                    className="hovering"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ct2-footer.png?_ts=1366977076"
                      alt="ČT2"
                      title="ČT2"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ct2-footer-hover.png?_ts=1366977075"
                      alt="ČT2"
                      title="ČT2"
                      className="on-hover"
                    />
                  </a>
                </div>
                <div className="w_1of2 first ct24">
                  <a
                    href="//ceskatelevize.cz/ct24/"
                    title="ČT24"
                    className="hovering"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ct24-footer.png?_ts=1366977075"
                      alt="ČT24"
                      title="ČT24"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ct24-footer-hover.png?_ts=1366977075"
                      alt="ČT24"
                      title="ČT24"
                      className="on-hover"
                    />
                  </a>
                </div>
                <div className="w_1of2 ctsport">
                  <a
                    href="//ceskatelevize.cz/sport/"
                    title="ČT sport"
                    className="hovering"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ctsport-footer.png?_ts=1378114922"
                      alt="ČT sport"
                      title="ČT sport"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ctsport-footer-hover.png?_ts=1378114922"
                      alt="ČT sport"
                      title="ČT sport"
                      className="on-hover"
                    />
                  </a>
                </div>
                <div className="w_1of2 first ctdecko">
                  <a
                    href="//decko.ceskatelevize.cz"
                    title="ČT :D"
                    className="hovering"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ctdecko-footer.png?_ts=1378477019"
                      alt="ČT :D"
                      title="ČT :D"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ctdecko-footer-hover.png?_ts=1378477018"
                      alt="ČT :D"
                      title="ČT :D"
                      className="on-hover"
                    />
                  </a>
                </div>
                <div className="w_1of2 ctart">
                  <a
                    href="//ceskatelevize.cz/art/"
                    title="ČT art"
                    className="hovering"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ctart-footer.png?_ts=1379344502"
                      alt="ČT art"
                      title="ČT art"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/icon-ctart-footer-hover.png?_ts=1379344501"
                      alt="ČT art"
                      title="ČT art"
                      className="on-hover"
                    />
                  </a>
                </div>
              </div>

              <hr className="clearfix hidden-phone" />

              <div className="aplikace">
                <div className="clearfix">
                  <div className="w_1of2 first">
                    <a
                      href="//ceskatelevize.cz/aplikace/"
                      title="Aplikace ČT"
                      className="hovering"
                    >
                      <img
                        src="//imgct.ceskatelevize.cz/global/images/icon-aplikace-footer.png?_ts=1377691802"
                        alt="Aplikace ČT"
                        title="Aplikace ČT"
                        className="off-hover"
                      />
                      <img
                        src="//imgct.ceskatelevize.cz/global/images/icon-aplikace-footer-hover.png?_ts=1377691802"
                        alt="Aplikace ČT"
                        title="Aplikace ČT"
                        className="on-hover"
                      />
                    </a>
                  </div>
                  <div className="w_1of2 last">
                    <a
                      href="//ceskatelevize.cz/hbbtv/"
                      title="HbbTV aplikace ČT"
                      className="hovering"
                    >
                      <img
                        src="//imgct.ceskatelevize.cz/global/images/icon-hbbtv-footer.png?_ts=1377691801"
                        alt="HbbTV aplikace ČT"
                        title="HbbTV aplikace ČT"
                        className="off-hover"
                      />
                      <img
                        src="//imgct.ceskatelevize.cz/global/images/icon-hbbtv-footer-hover.png?_ts=1377691802"
                        alt="HbbTV aplikace ČT"
                        title="HbbTV aplikace ČT"
                        className="on-hover"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-social">
              <p className="visible-desktop">Sledujte nás také na</p>
              <div className="clearfix">
                <div className="w_1of4 first">
                  <a
                    className="hovering"
                    href="//www.facebook.com/ceskatelevize?v=wall"
                    title="Facebook"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-facebook.png?_ts=1366977075"
                      alt="Facebook"
                      title="Facebook"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-facebook-hover.png?_ts=1366977075"
                      alt="Facebook"
                      title="Facebook"
                      className="on-hover"
                    />
                  </a>
                </div>
                <div className="w_1of4">
                  <a
                    className="hovering"
                    href="//www.twitter.com/czechtv"
                    title="Twitter"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-twitter.png?_ts=1366977075"
                      alt="Twitter"
                      title="Twitter"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-twitter-hover.png?_ts=1366977075"
                      alt="Twitter"
                      title="Twitter"
                      className="on-hover"
                    />
                  </a>
                </div>

                <div className="w_1of4">
                  <a
                    className="hovering"
                    href="//www.instagram.com/ceskatelevize/"
                    title="Instagram"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-instagram.png"
                      alt="Instagram"
                      title="Instagram"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-instagram-hover.png"
                      alt="Instagram"
                      title="Instagram"
                      className="on-hover"
                    />
                  </a>
                </div>

                <div className="w_1of4 last">
                  <a
                    className="hovering"
                    href="//www.youtube.com/ceskatelevize/"
                    title="Youtube"
                  >
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-youtube.png"
                      alt="Youtube"
                      title="Youtube"
                      className="off-hover"
                    />
                    <img
                      src="//imgct.ceskatelevize.cz/global/images/footer-youtube-hover.png"
                      alt="Youtube"
                      title="Youtube"
                      className="on-hover"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="wrapper-copyright">
      <div id="copyright" className="wrapper clearfix" role="contentinfo">
        <p className="f-right">
          <a href="//ceskatelevize.cz/mapa-stranek/" title="Mapa stránek">
            Mapa stránek
          </a>{' '}
          |{' '}
          <a href="//ceskatelevize.cz/rss/" title="RSS">
            RSS
          </a>
        </p>
        <p className="f-left">
          &copy;{' '}
          <a href="//ceskatelevize.cz/" title="Česká televize">
            Česká televize
          </a>{' '}
          1996 &ndash; 2018 |{' '}
          <a href="//ceskatelevize.cz/english/" title="English">
            English
          </a>
        </p>
      </div>
      <div id="cookie-notice" className="wrapper clearfix">
        Při poskytování služeb nám pomáhají soubory cookie. Používáním webu
        vyjadřujete souhlas.{' '}
        <a href="/ochrana-soukromi/" title="Více informací">
          Ochrana soukromí
        </a>.
      </div>
    </div>
  </div>
);

export default CtFoot;



// WEBPACK FOOTER //
// ./src/components/App/Program/List/CtFoot/CtFoot.js